import { render } from "./LoginCompanyPage.vue?vue&type=template&id=aa76dc50&ts=true"
import script from "./LoginCompanyPage.vue?vue&type=script&lang=ts"
export * from "./LoginCompanyPage.vue?vue&type=script&lang=ts"

import "./LoginCompanyPage.vue?vue&type=style&index=0&id=aa76dc50&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__